import {
  InstructorRemovalOutcome,
  InstructorRemovalReason,
  InstructorRemovalSnapshot,
} from "./types";

export const getInstructorCorrectionValidity = (
  snapshot: Pick<InstructorRemovalSnapshot, "instructors">,
) => {
  const responsibilityTotal = snapshot.instructors.reduce(
    (total, instructor) => total + instructor.responsibility,
    0,
  );
  const primaryCount = snapshot.instructors.filter(instructor => instructor.isPrimary).length;

  return {
    responsibilityTotal,
    primaryCount,
    responsibilityValid: responsibilityTotal === 100,
    primaryValid: primaryCount === 1,
    valid: snapshot.instructors.length > 0 && responsibilityTotal === 100 && primaryCount === 1,
  };
};

export const classifyInstructorRemoval = (
  before: InstructorRemovalSnapshot,
  after: InstructorRemovalSnapshot,
  pendingReplacement = false,
): InstructorRemovalOutcome => {
  const savedById = new Map(
    after.instructors.map(instructor => [instructor.instructorId, instructor]),
  );
  const validity = getInstructorCorrectionValidity(after);
  const reasons: InstructorRemovalReason[] = [];

  // Besides the instructors that left the league, the ones the backend dropped in place count
  // (CHS-2944): they stay with a group drop date, no responsibility and no primary status.
  const responsibilityWasAffected = before.instructors.some(instructor => {
    const saved = savedById.get(instructor.instructorId);
    return instructor.responsibility > 0 && (!saved || saved.responsibility === 0);
  });
  const primaryWasAffected = before.instructors.some(instructor => {
    const saved = savedById.get(instructor.instructorId);
    return instructor.isPrimary && (!saved || !saved.isPrimary);
  });

  if ((pendingReplacement || responsibilityWasAffected) && !validity.responsibilityValid) {
    reasons.push("responsibility");
  }

  if ((pendingReplacement || primaryWasAffected) && !validity.primaryValid) {
    reasons.push(validity.primaryCount > 1 ? "primary-multiple" : "primary-missing");
  }

  return {
    reasons,
    hasNoInstructors: after.instructors.length === 0,
  };
};
